module.exports = __webpack_public_path__ + "img/company40.f20c0818.png";